import React from 'react';
import FilterTable from './filterTable';
import {
  AccountsTableColumnCaptions,
} from './tableColumnCaptions';
import { Link } from 'react-router-dom';
import extractSearchParams from '../common/extractSearchParams';

const unrelated = 'Unrelated';

const AccountsTable = props => {
  const providersFilterValues = { 'all': '' };
  props.providers.forEach(provider => providersFilterValues[provider.name] = provider.name);

  const columns = [{
    dataField: 'login',
    text: AccountsTableColumnCaptions.login,
    sort: true,
    filter_: { type: 'text' },
    defaultValue: extractSearchParams(props.requestData.location.search, 'login'),
    formatter: (cell, account) => {
      return (
        <span onClick={props.handleLoginClick(account)}>{cell}</span>
      )
    },
  }, {
    dataField: 'deviceKey',
    text: AccountsTableColumnCaptions.device.key,
    sort: true,
    filter_: { type: 'text' },
    headerStyle: () => ({ width: '15em' }),
    formatter: (cell) => {
      const isKey = cell !== unrelated;
      return isKey ? <Link to={`/history?device.key=${cell}`}>{cell}</Link> : cell;
    },
  }, {
    dataField: 'provider.name',
    text: AccountsTableColumnCaptions.provider.key,
    sort: true,
    filter_: {
      type: 'select', values: providersFilterValues,
    },
    defaultValue: extractSearchParams(props.requestData.location.search, 'provider'),
    headerStyle: () => ({ width: '15em' }),
  }, {
    dataField: 'isSuper',
    text: AccountsTableColumnCaptions.isSuper,
    sort: false,
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'true': 'true',
        'false': 'false'
      }
    }
  }];

  const defaultSorted = [{
    dataField: 'name',
    order: 'asc'
  }];

  const accounts = props.accounts.map(element => {
    const rElem = { ...element };
    if (rElem.device !== null) {
      rElem.deviceKey = rElem.device.key;
    } else {
      rElem.deviceKey = unrelated;
    }
    return rElem;
  });

  return (
    <FilterTable
      {...props}
      objectName="accounts"
      data={accounts}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no accounts"
    />
  );
};

export default AccountsTable;



// WEBPACK FOOTER //
// ./src/components/accountsTable.js